/** @module Enums */ /** typedoc */

/**
 *
 * Zero-decimal currencies (https://support.stripe.com/questions/which-zero-decimal-currencies-does-stripe-support)

 - BIF: Burundian Franc
 - CLP: Chilean Peso
 - DJF: Djiboutian Franc
 - GNF: Guinean Franc
 - JPY: Japanese Yen
 - KMF: Comorian Franc
 - KRW: South Korean Won
 - MGA: Malagasy Ariary
 - PYG: Paraguayan Guaraní
 - RWF: Rwandan Franc
 - VND: Vietnamese Đồng
 - VUV: Vanuatu Vatu
 - XAF: Central African Cfa Franc
 - XOF: West African Cfa Franc
 - XPF: Cfp Franc
 */

export enum ZeroDecimalCurrenciesEnum {
    BIF = 'BIF',
    DJF = 'DJF',
    JPY = 'JPY',
    KRW = 'KRW',
    PYG = 'PYG',
    VND = 'VND',
    XAF = 'XAF',
    XPF = 'XPF',
    CLP = 'CLP',
    GNF = 'GNF',
    KMF = 'KMF',
    MGA = 'MGA',
    RWF = 'RWF',
    VUV = 'VUV',
    XOF = 'XOF'
}
